<hs-mvt-checkbox-control
  [formControl]="basisControl"
  [sourceAccountId]="sourceAccountId"
  [tranType]="tranType"
  [entryDate]="entryDate"
  [editMode]="editMode"
  (basisUpdate)="onBasisUpdate($event)"
  (inOutMvtBases)="setInOutMvtBases($event)"
  (errorDetails)="setErrorDetails($event)"
  (errorHeader)="setErrorHeader($event)"
></hs-mvt-checkbox-control>

<nf-table-layout
  class="exchange-table"
  hideTitle
  [isSectionTitle]="false"
  [gridOptions]="gridOptions"
  [data]="rowData"
  hideSearch
  [autoResizeGrid]="false"
  hideClearAll
>
</nf-table-layout>
